import React from 'react';
import SubLinksHeader from './sublinks-header';
import SubLinks from '../../common/sub-links';
import FlexDivider from '../../../../basic/flex-divider';
import { ILinks, IMainNavigation, INavlinksProps } from '../../IFooter';

const Navlinks = ({ navlinks }: INavlinksProps): JSX.Element => {
  return (
    <div className="flex flex-col my-base ">
      {navlinks.map((ele: IMainNavigation, key: number) => {
        const menus = ele.subLinks;
        const accordianCls = ele.navigationHeader.toLowerCase().replaceAll(' ', '-');
        return (
          <div key={`accordian-${key}`}>
            <div className="flex-1 py-sm " key={`ft-mb-hdr-${key}`}>
              <SubLinksHeader
                navigationHeader={ele.navigationHeader}
                key={`ft-mb-slh-${key}`}
                accordianCls={accordianCls}
              />
              <div className={`${accordianCls} flex-none hidden`}>
                <div className="text-sm text-white pt-4 pl-7">
                  {menus?.map((item: ILinks, index: number) => {
                    return <SubLinks key={`ft-mb-sls-${index}`} items={item} />;
                  })}
                </div>
              </div>
            </div>
          </div>
        );
      })}
    </div>
  );
};

export default Navlinks;
